import { Link, useNavigate } from "react-router-dom";
import { SignOut } from "@/components/icons";
import { Coins, House, Sparkle } from "lucide-react";
import { useAuth } from "@/context/AuthContext";

export default function Navbar() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  return (
    <header className="sticky top-0 z-50 bg-ink-950/70 backdrop-blur-xl border-b border-white/10">
      <div className="max-w-[1600px] mx-auto px-5 sm:px-8 h-16 flex items-center justify-between">
        <Link to="/home" data-testid="navbar-home" className="flex items-center gap-2 px-3 py-2 text-sm font-medium text-zinc-400 hover:text-white transition-colors">
          <House size={18} /> <span className="hidden sm:inline">Home</span>
        </Link>

        <nav className="flex items-center gap-1 sm:gap-2">
          <Link to="/wallet" data-testid="nav-coins" className="flex items-center gap-1.5 px-2.5 py-1.5 rounded-full border border-yellow-500/40 bg-[#1a140d] hover:border-yellow-400 transition-colors">
            <Coins size={15} className="text-yellow-400" />
            <span className="font-mono text-sm text-yellow-300 font-semibold" data-testid="coin-balance">{Math.round(user?.spendable_coins ?? user?.coin_balance ?? 0)}</span>
          </Link>
          <Link to="/pricing" data-testid="nav-credits" className="flex items-center gap-1.5 px-2.5 py-1.5 rounded-full border border-gold/40 bg-[#1a140d] hover:border-gold transition-colors">
            <Sparkle size={14} className="text-gold" />
            <span className="font-mono text-sm text-gold font-semibold" data-testid="credit-balance">{user?.role === "admin" ? "∞" : (user?.credits ?? 0)}</span>
          </Link>
          <div className="w-px h-6 bg-zinc-800 mx-1 sm:mx-2" />
          <span className="hidden md:block label-mono mr-2">{user?.name}</span>
          <button
            onClick={() => { logout(); navigate("/"); }}
            data-testid="nav-logout"
            className="flex items-center gap-2 px-3 py-2 text-sm font-medium text-zinc-400 hover:text-destructive transition-colors"
          >
            <SignOut size={18} /> <span className="hidden sm:inline">Exit</span>
          </button>
        </nav>
      </div>
    </header>
  );
}
